import React, { Component } from "react";

class Service extends Component{
    render(){
        let data = [
            {
                icon: 'zmdi zmdi-settings',
                title: 'Простота настройки',
                desc: 'Пользоваться программой очень легко и просто. Достаточно один раз просмотреть '
            },

            {
                icon: 'zmdi zmdi-favorite',
                title: 'Дружественный интерфейс',
                desc: 'Красивый и интуитивно-понятный интерфейс с большими возможностями настройки отображения блок-схем.'
            },

            {
                icon: 'zmdi zmdi-time',
                title: 'Поддержка 24/7',
                desc: 'Мы стараемся отвечать на Ваши вопросы в режиме 24/7'
            }
        ];
        let DataList = data.map((val, i) => {
            return(
                <div className="col-lg-4 service-column" key={i}>
                    <div className="single-service text-center">
                        <div className="service-icon">
                            <i className={`${val.icon}`}></i>
                        </div>
                        <h3 className="title">{val.title}</h3>
                        <p className="desc">{val.desc}{(i==0) ? <a className="button-nav underline theme-color" href="/#video">видео-обучение</a> : ''}</p>
                    </div>
                </div>
            )
        });

        return (
            <div>
                {/* Start Service Area */}
                <div className={`service-area ${this.props.horizontal}`}>
                    <div className="container">
                        <div className="row">
                            {DataList}
                        </div>
                    </div>
                </div>
                {/* End Service Area */}
            </div>
        )
    }
}

export default Service;

